<div class="schedule-logs-container" *ngIf="data$ | async as automationProcessRegisterTableData">
  <div class="table-heading">Execution Logs</div>

  <app-filter-panel
    [filterProps]="filterProps"
    [filters]="filters"
    (filtersChanged)="onFilterChange($event)">
  </app-filter-panel>

  <app-table
    *ngIf="automationProcessRegisterTableData?.content"
    [columns]="automationRegisterProcessColumns"
    [tableData]="automationProcessRegisterTableData"
    (pageChange)="onPageChange($event)"
    (sortChange)="onSortChange($event)"
    (cellClick)="handleCellClick($event)">
  </app-table>
</div>
